import { DialogObject } from '@/components/dialog/dialog.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicField, FieldVariant, FileFieldProps } from '@/components/form-builder/form-builder.types';
import { BehaviorSubject } from 'rxjs';
import { FileRemoveEvent, FileSelectEvent } from 'primeng/fileupload';

interface GetDynaCopyUploadDialogProps {
  file$: BehaviorSubject<File[]>;
  validate: () => void;
}

export const getDynaCopyUploadDialog = ({ file$, validate }: GetDynaCopyUploadDialogProps): DialogObject => {
  const modifiedDocFile: DynamicField<FileFieldProps> = {
    label: 'Téléversez le document modifié',
    variant: FieldVariant.FILE,
    isRequired: true,
    props: {
      mode: 'basic',
      accept: '.docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      multiple: false,
      value: file$.asObservable(),
      onFileSelect: (event: FileSelectEvent) => {
        file$.next(event.currentFiles);
      },
      onFileRemoved: (event: FileRemoveEvent) => {
        file$.next(file$.getValue().filter(f => f.name !== event.file.name));
      },
      message: 'common.files.warn',
    },
  };

  return {
    title: 'Téléversez le document modifié',
    actions: [
      {
        label: 'Valider',
        variant: 'success',
        onClick: () => validate(),
      },
    ],
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject: {
          title: '',
          description: '',
          isHeaderHidden: true,
          class: '',
          grids: [
            {
              title: '',
              isHeaderHidden: true,
              gridItems: [
                {
                  fields: [modifiedDocFile],
                },
              ],
            },
          ],
        },
      },
    },
  };
};
